module.exports = {"632726100":"约改镇","632726200":"巴干乡","632726201":"秋智乡","632726202":"叶格乡","632726203":"麻多乡","632726204":"曲麻河乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/632726.json
// module id = 3016
// module chunks = 0